import $ from 'jquery';

export default () => {

    $('.hamburger').on("click", function () {
        $(this).addClass('put-back');
        $('.menu-items').height($(window).height() + "px");
        $('.menu-hamburger').css('background-color', 'white');
        $('header.trasparente .mobile .logo img.img-fluid').css('filter', 'none');
        console.log($( window ).height());
        setTimeout(() => {
            $('.btn-x').removeClass('put-back');
        }, 300)
    });
    $('.btn-x').on("click", function () {
        $(this).addClass('put-back');
        $('.menu-items').height("0px");
        setTimeout(() => {
            $('header.trasparente .mobile .logo img.img-fluid').css('filter', 'invert(1)');
            $('.menu-hamburger').css('background-color', 'transparent');
            $('.hamburger').removeClass('put-back');
        }, 300)
    });


    $('.mobile-item.has-children').on('click', function (event) {
        //event.preventDefault();
        var current = $( this );

        $('.mobile-item.has-children').each(function() {
            if( $(this)[0] != current[0] ) {
                $( this )[0].children[1].style.transform = "rotate(0deg)";
                $( this )[0].lastElementChild.style.height = "0px";
            } else {
                $( this )[0].children[1].style.transform = "rotate(180deg)";
            }
        });

        if( $(this)[0].lastElementChild.style.height == 0 || $(this)[0].lastElementChild.style.height == "0px") {
            $(this)[0].lastElementChild.style.height = $(this)[0].lastElementChild.children[0].offsetHeight + "px";
        } else {
            $(this)[0].children[1].style.transform = "rotate(0deg)";
            $(this)[0].lastElementChild.style.height = "0px";
        }
    });

}


// WEBPACK FOOTER //
// ../views/partials/hamburger/hamburger.js